// extracted by mini-css-extract-plugin
export default {"defaultLinkStyle":"OwnListingLink_defaultLinkStyle__TNUBe a"};